module.exports = __webpack_public_path__ + "img/news_left.7b8639a6.png";